enum TransferringStatus {
    WAITING,
    UPLOADING,
    UPLOADING_ERROR,
    TRANSFERRING_WAITING,
    TRANSFERRING,
    TRANSFERRING_ERROR,
    TRANSFERRING_ERROR_MESSAGE,
    FINISHED,
}

export default TransferringStatus;
